import { forwardRef, createElement } from 'react';

function IconMileage(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M12 2c5.523 0 10 4.477 10 10 0 1.806-.479 3.5-1.316 4.962L20.66 17a.75.75 0 01-.933.32l-.091-.045-1.516-.875a.75.75 0 01.659-1.344l.091.044.84.485c.406-.874.67-1.83.757-2.834l-.967-.001a.75.75 0 01-.102-1.493l.102-.007h.967a8.447 8.447 0 00-.757-2.834l-.84.484a.75.75 0 01-.835-1.243l.085-.057.838-.483a8.548 8.548 0 00-2.075-2.075l-.483.838a.75.75 0 01-1.344-.659l.044-.091.484-.84a8.447 8.447 0 00-2.833-.757l-.001.967a.75.75 0 01-1.493.102L11.25 4.5v-.967a8.447 8.447 0 00-2.834.757l.484.84a.75.75 0 01-1.243.835L7.6 5.88l-.483-.838a8.548 8.548 0 00-2.075 2.075l.838.483a.75.75 0 01-.659 1.344L5.13 8.9l-.84-.484a8.447 8.447 0 00-.757 2.834H4.5a.75.75 0 01.102 1.493l-.102.007h-.967a8.427 8.427 0 00.758 2.835l.839-.485a.75.75 0 01.835 1.243l-.085.057-1.516.875A.75.75 0 013.34 17l-.02-.04-.003.003A9.954 9.954 0 012 12C2 6.477 6.477 2 12 2zm4.03 5.97a.75.75 0 01.073.976l-.073.084-2.792 2.794a1.25 1.25 0 11-1.061-1.061L14.97 7.97a.75.75 0 011.06 0z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Mileage = /*#__PURE__*/forwardRef(IconMileage);

export default Mileage;
//# sourceMappingURL=Mileage.js.map
